import { SocialAccount } from 'types';

export const SEARCH_THRESHOLD = 5;

export const filterAccounts = (accounts: SocialAccount[], searchTerm: string): SocialAccount[] => {
  const term = searchTerm.trim().toLowerCase();
  if (!term) return accounts;
  return accounts.filter(account => account.client?.toLowerCase().includes(term));
};
